import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  fill?: string;
};

const InvoicesIcon = ({ className, fill = "black" }: Props) => {
  return (
    <svg
      className={cn("h-[27px] w-5 shrink-0", className)}
      viewBox="0 0 20 27"
      fill={fill || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
    <path
      d="M12.2229 13.4998C12.8365 13.4999 13.3337 14.0036 13.3337 14.6249C13.3337 15.2461 12.8364 15.7495 12.2229 15.7496H5.55623C4.94263 15.7496 4.44506 15.2462 4.44499 14.6249C4.44499 14.0036 4.94258 13.4998 5.55623 13.4998H12.2229Z"
      fill={fill}
    />
    <path
      d="M14.445 8.99973C15.0586 8.99973 15.5562 9.50353 15.5562 10.1248C15.5562 10.7461 15.0586 11.2496 14.445 11.2496H5.55623C4.94263 11.2496 4.44506 10.7461 4.44499 10.1248C4.44499 9.50353 4.94258 8.99973 5.55623 8.99973H14.445Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4446 0C15.9174 0.00182245 17.3293 0.595116 18.3708 1.64957C19.4122 2.70403 19.9982 4.13355 20 5.62478V25.8745C19.9995 26.0788 19.9441 26.2793 19.8397 26.4541C19.7352 26.6289 19.5856 26.7716 19.4071 26.8669C19.2286 26.9622 19.0276 27.0066 18.8261 26.9951C18.6246 26.9835 18.4301 26.9164 18.2633 26.8014L15.9302 25.1848L13.5966 26.8027C13.4116 26.9311 13.1926 27 12.9683 27C12.7441 27 12.5251 26.9311 12.3401 26.8027L10.0065 25.184L7.67334 26.8027C7.48846 26.9308 7.26956 26.9996 7.04549 26.9996C6.82145 26.9996 6.6025 26.9308 6.41764 26.8027L4.07796 25.184L1.73787 26.8027C1.57099 26.9181 1.37608 26.9851 1.17432 26.9967C0.972561 27.0083 0.771597 26.964 0.592855 26.8686C0.414103 26.7731 0.264351 26.6301 0.159912 26.4549C0.0555088 26.2798 0.000156512 26.0791 0 25.8745V5.62478C0.00180013 4.13355 0.587777 2.70403 1.62923 1.64957C2.67069 0.595115 4.08259 0.00182261 5.55542 0H14.4446ZM5.55542 2.24983C4.67141 2.24986 3.82374 2.60569 3.19865 3.23858C2.57356 3.87148 2.22212 4.72973 2.22209 5.62478V23.7371L3.45337 22.8913C3.63809 22.7634 3.85662 22.6948 4.0804 22.6948C4.30424 22.6948 4.52308 22.7634 4.70784 22.8913L7.04102 24.51L9.37459 22.8913C9.55958 22.7629 9.77856 22.694 10.0028 22.694C10.2271 22.694 10.4461 22.7629 10.6311 22.8913L12.9643 24.51L15.2979 22.8913C15.4829 22.7627 15.702 22.6936 15.9265 22.6936C16.151 22.6936 16.3705 22.7626 16.5556 22.8913L17.7779 23.7371V5.62478C17.7779 4.72973 17.4264 3.87148 16.8013 3.23858C16.1763 2.60569 15.3286 2.24986 14.4446 2.24983H5.55542Z"
      fill={fill}
    />
    </svg>
  );
};

export default InvoicesIcon;
